import React from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { erabChartConfig } from '../chartConfigs';

/**
 * Props for the ErabEstablishmentEcharts component
 */
interface ErabEstablishmentEchartsProps {
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * ERAB Establishment Success Rate Chart (LTE Site Level)
 * 
 * Displays aggregated E-UTRAN Radio Access Bearer (ERAB) establishment metrics across all cells in an LTE site:
 * - ERAB Establishment Success (count)
 * - ERAB Establishment Attempt (count)
 * - ERAB Establishment Success Rate (percentage)
 * 
 * This component is a thin wrapper around the SiteCharts template component,
 * configured with site-level ERAB metrics from chartConfigs.ts
 * 
 * @component
 * @example
 * ```tsx
 * <ErabEstablishmentEcharts
 *   onFullscreenToggle={() => setFullscreen(!fullscreen)}
 *   isFullscreen={false}
 * />
 * ```
 * 
 * @see {@link ../chartConfigs.ts} - Chart configuration (erabChartConfig)
 * @see {@link ../../../components/SiteCharts.tsx} - Template component
 * @see API: /api/lte/erab-establishment?site_name={siteName}
 */

const ErabEstablishmentEcharts: React.FC<ErabEstablishmentEchartsProps> = ({ 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  return (
    <SiteCharts 
      config={erabChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
    />
  );
};

export default ErabEstablishmentEcharts;
